import { Typography, Badge as AntdBadge } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px;
  gap: 10px;

  & .ant-badge {
    display: flex;
    align-items: center;
  }
`;

export const Title = styled(Typography.Title)`
  color: var(--ant-primary-7) !important;
  margin: 0 !important;
`;

export const Badge = styled(AntdBadge)``;

export const Actions = styled.div``;
